module.exports = __webpack_public_path__ + "static/img/1-2.4ad70cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/6/1/1-2.png
// module id = fcbS
// module chunks = 0